export const MODAL_UNSAVED_DATA_WARNING_TITLE =
  'Вы уверены, что хотите закрыть окно?';
export const PAGE_UNSAVED_DATA_WARNING_TITLE =
  'Вы уверены, что хотите покинуть страницу?';
export const UNSAVED_DATA_WARNING_TEXT =
  'Введенные вами данные будут потеряны.';
